import { Injectable } from '@angular/core';


@Injectable()
export class ActivateComponentService {
    public entitlementsForUser=[];
    public expiredEntitlements = [];
    public entitlementToExpireDate = {};

    activatedProducts:any;
    constructor(
    ){
    }

    getActivated(){
        return this.activatedProducts;
    }

    setActivated(activatedProducts){
        this.activatedProducts = activatedProducts;
    }
    
    updateEntitlementsForUser(productCode) {
        this.entitlementsForUser.push(productCode);
    }

    getEntitlementsForUser(){
        return this.entitlementsForUser;
    }

    getExpiredEntitlementsForUser(){
        return this.expiredEntitlements;
    }

    setEntitlementsForUser(entitlements) {
        this.entitlementsForUser = entitlements;
    }

    setExpiredEntitlementsForUser(entitlements, entitlementToExpireDate) {
        this.expiredEntitlements = entitlements;
        this.entitlementToExpireDate = entitlementToExpireDate;
    }

    getEntitlementToExpireDateForUser(){
        return this.entitlementToExpireDate;
    }
}